
import React, { useState } from 'react';
import { Home, History, User, Globe } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toggleLanguage } from '@/i18n';
import { HistoryDialog } from './footer/HistoryDialog';

const Footer = () => {
  const navigate = useNavigate();
  const [showHistory, setShowHistory] = useState(false);
  const { t, i18n } = useTranslation();
  
  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleLanguageToggle = () => {
    toggleLanguage();
  };

  const getCurrentLanguageName = () => {
    const currentLang = i18n.language;
    if (currentLang.startsWith('fr')) return 'FR';
    if (currentLang.startsWith('en')) return 'EN';
    if (currentLang.startsWith('ar')) return 'AR';
    return 'FR'; // Default to French if unknown
  };

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 h-16 bg-white border-t flex justify-center items-center">
        <div className="flex w-full max-w-md justify-around">
          <Link to="/" className="flex flex-col items-center">
            <Home className="h-6 w-6 text-gray-500" />
            <span className="text-xs text-gray-500">{t('nav.home')}</span>
          </Link>
          <div 
            className="flex flex-col items-center cursor-pointer"
            onClick={() => setShowHistory(true)}
          >
            <History className="h-6 w-6 text-gray-500" />
            <span className="text-xs text-gray-500">{t('common.history')}</span>
          </div>
          <div 
            className="flex flex-col items-center cursor-pointer"
            onClick={handleLanguageToggle}
            title={t('language.switch')}
            aria-label={t('language.switch')}
          >
            <Globe className="h-6 w-6 text-gray-500" />
            <span className="text-xs text-gray-500">{getCurrentLanguageName()}</span>
          </div>
          <div 
            className="flex flex-col items-center cursor-pointer"
            onClick={handleProfileClick}
          >
            <User className="h-6 w-6 text-gray-500" />
            <span className="text-xs text-gray-500">{t('nav.profile')}</span>
          </div>
        </div>
      </div>
      
      <HistoryDialog open={showHistory} onOpenChange={setShowHistory} />
    </>
  );
};

export default Footer;
